import { SITE } from "~/lib/constants";
import type { Image } from "~/lib/post";

type Props = Readonly<{
  image: Image;
  link?: string;
  className?: string;
}>;

export function CoverImage({
  image,
  link,
  className = "",
}: Props): JSX.Element {
  return (
    <div className="sm:mx-0">
      {link ? (
        <a href={link}>
          <img
            src={image.url}
            alt={image.alt ?? SITE.company}
            className={className}
          />
        </a>
      ) : (
        <img
          src={image.url}
          alt={image.alt ?? SITE.company}
          className={className}
        />
      )}
    </div>
  );
}
